import { internalLogger } from '../interface/v1/clientOsLogger';

export default function createScript(
  scriptId: string,
  src: string
): HTMLScriptElement {
  const script = document.createElement('script');

  script.setAttribute('id', scriptId);
  script.setAttribute('charset', 'UTF-8');
  script.setAttribute('src', src);

  return script;
}

/**
 * Creates an inline script element with content
 */
export function createInlineScript(
  scriptId: string,
  content: string
): HTMLScriptElement {
  const script = document.createElement('script');
  script.setAttribute('id', scriptId);
  script.setAttribute('type', 'text/javascript');
  script.innerHTML = content;
  return script;
}

/**
 * Checks if a script with the given ID already exists
 */
export function scriptExists(scriptId: string): boolean {
  return !!document.getElementById(scriptId);
}

/**
 * Inserts a script into the document head
 */
export function insertScript(
  script: HTMLScriptElement,
  position: 'prepend' | 'append' = 'append'
): void {
  if (position === 'prepend' && document.head.prepend) {
    document.head.prepend(script);
  } else {
    document.head.appendChild(script);
  }
}

/**
 * Creates and adds a preconnect link if it doesn't exist
 */
export function addPreconnectLink(href: string): boolean {
  const existing = document.querySelector(
    `link[rel="preconnect"][href="${href}"]`
  );
  if (existing) return false;

  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  document.head.appendChild(link);
  return true;
}

/**
 * Adds error handling to script elements
 */
export function addScriptErrorHandling(
  script: HTMLScriptElement,
  scriptType: string
): void {
  script.onerror = (error) => {
    internalLogger.error(`Failed to load ${scriptType} script`, {
      src: script.src,
      error
    });
  };

  script.onload = () => {
    internalLogger.debug(`${scriptType} script loaded successfully`);
  };
}
